export const domainPathname = process.env.REACT_APP_MODE === "production" ? window.location.origin : process.env.PUBLIC_URL

export const normalizeBoolean = (value: string) => {
    if (value === "true") return true
    if (value === "false" || undefined || "undefined") return false
    return value
}

export const sortByProperty = (property: string) => {
   return function(a, b){
      if(a[property] > b[property])
         return 1
      else if(a[property] < b[property])
         return -1

      return 0
   }
}

export const getProtectedEmail = (mail: string) => {
    const splittedEmail = mail.split("@")
    const addX = new Array(splittedEmail[0].slice(2).length + 1).join("*")

    return splittedEmail[0].slice(0, 2) + addX + "@" + splittedEmail[1]
}

export const openInNewTab = (url: string, { focus = false }) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer")
    if (newWindow) newWindow.opener = null
    if (focus && newWindow !== null) newWindow.focus()
}